<template>
  <section id="WhyGroupTickets">
    <div id="WhyGroupTickets-selector"></div>
    <b-container>
      <div class="title"><span>why</span> group<br />tickets?</div>
      <div class="divider" />
      <div class="benefits">
        <div
          class="benefit"
          v-for="(benefit, index) in benefits"
          :key="'benefit' + index"
        >
          <div class="benefit__icon">
            <img class="bg" :src="benefit.bg" />
            <img class="icon" :src="benefit.icon" />
          </div>
          <div class="benefit__title" v-html="benefit.title"></div>
          <div class="benefit__description" v-html="benefit.description" />
        </div>
      </div>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "WhyGroupTickets",
  data() {
    return {
      benefits: [
        {
          bg: require("@/assets/icons/Benefits/icon_circle-red.svg"),
          icon: require("@/assets/icons/Benefits/icon_easy-to-plan.svg"),
          title: "easy to<br>plan",
          description:
            "Securing your group is way easier than you think. Ticket distribution is also easier than ever, learn more <a href='https://www.mlb.com/rangers/tickets/groups/group-tickets-tool' target='_blank'>here</a>.",
        },
        {
          bg: require("@/assets/icons/Benefits/icon_circle-blue.svg"),
          icon: require("@/assets/icons/Benefits/icon_best-value.svg"),
          title: "best<br>value",
          description:
            "Save money on tickets when you book a group outing (vs. single game tickets).",
        },
        {
          bg: require("@/assets/icons/Benefits/icon_circle-red.svg"),
          icon: require("@/assets/icons/Benefits/icon_food-and-bev.svg"),
          title: "food & beverage<br>options",
          description:
            "Maximize your time together with our food & beverage packages. Or you can get tickets with loaded value redeemable at Globe Life Field concession stands.",
        },
        {
          bg: require("@/assets/icons/Benefits/icon_circle-blue.svg"),
          icon: require("@/assets/icons/Benefits/icon_climate-controlled.svg"),
          title: "climate-<br>controlled",
          description:
            "Stay comfortable with our 72 degree ballpark temperatures all year long.",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
#WhyGroupTickets {
  width: 100%;
  background: linear-gradient(135deg, #002d74 0%, #040c18 100%);
  padding: 90px 0 100px 0;
  margin-top: 25px;
  @media (max-width: $md) {
    padding: 70px 0;
  }
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .title {
    font-family: BertholdCondensed;
    font-size: 40px;
    line-height: 32px;
    letter-spacing: 0;
    color: #ffffff;
    text-transform: uppercase;
    span {
      font-weight: 700;
    }
  }
  .divider {
    height: 2px;
    width: 70px;
    background-color: #ffffff;
    margin: 10px 0 65px 0;
  }
  .benefits {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    @media (max-width: $md) {
      flex-direction: column;
    }
    .benefit {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: calc(25% - 20px);
      max-width: 195px;
      @media (max-width: $md) {
        width: 100%;
        max-width: 100%;
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      &__icon {
        position: relative;
        width: 94px;
        height: 94px;
        border-radius: 50%;
        overflow: hidden;
        .bg {
          width: 100%;
          height: 100%;
          animation: rotation 4s infinite linear;
          @keyframes rotation {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(359deg);
            }
          }
        }
        .icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      &__title {
        font-family: BertholdCondensed;
        font-weight: 700;
        font-size: 25px;
        line-height: 23px;
        letter-spacing: 0;
        text-align: center;
        color: #ffffff;
        text-transform: uppercase;
        padding: 10px 0;
        margin: 16px 0 18px 0;
        border-top: 1px solid rgba(255, 255, 255, 0.25);
        border-bottom: 1px solid rgba(255, 255, 255, 0.25);
        width: 100%;
      }
      &__description {
        font-family: Gotham;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0;
        text-align: center;
        color: #ffffff;
      }
    }
  }
}
</style>
